module.exports = __webpack_public_path__ + "img/HZGB12-9w.800851c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB12-9w.png
// module id = sCFa
// module chunks = 0